import { isUndefined } from '@fxts/core';
import { font } from '@services/MarppleShop/shared/typography';
import { makePlusUrl } from '@services/MarppleShop/shared/util/url.ts';
import { html, View } from 'rune-ts';
import { Menu } from '../../libs/types/header';
import klass from './CreatorShopSubHeader.module.scss';

type CreatorShopSubHeaderData = {
  menus: Menu[];
  plus_domain?: string;
  focus_on_select?: boolean;
};

/**
 * @desc 크리에이터 샵 모바일에서 사용하는 서브 헤더입니다.
 */
export class CreatorShopSubHeader extends View<CreatorShopSubHeaderData> {
  constructor(data: CreatorShopSubHeaderData) {
    if (isUndefined(data.focus_on_select)) {
      data.focus_on_select = true;
    }

    super(data);
  }

  override template() {
    return html`<div class="${klass.sub_header}">
      ${this.data.menus.map(
        (menu) =>
          html`<a
            target="${menu.target || '_self'}"
            href="${makePlusUrl(this.data.plus_domain, menu.url)}"
            class="${klass.item} ${font('14_medium')}"
            data-selected="${menu.is_selected}"
            >${menu.name}</a
          >`,
      )}
      <!-- 첫 로드 시 선택된 아이템으로 스크롤 -->
      ${this.data.focus_on_select
        ? html` <script>
            document
              .querySelector('.${klass.item}[data-selected="true"]')
              ?.scrollIntoView({ behavior: 'instant', inline: 'start' });
          </script>`
        : ''}
    </div>`;
  }
}
